import { render } from "./Layout.vue?vue&type=template&id=3b812f61&scoped=true&ts=true"
import script from "./Layout.vue?vue&type=script&lang=ts"
export * from "./Layout.vue?vue&type=script&lang=ts"

import "./Layout.vue?vue&type=style&index=0&id=3b812f61&lang=sass&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/IT_CICD/SDK/Prod/Joymeet_frontend/GUI/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b812f61"]])

export default __exports__